import Model from '@models/Model'
import FormResponse from "@models/FormResponse"
import User from '@models/User'
import IssueActivityItem from "@models/IssueActivityItem"

class Issue extends Model {
  constructor (initialData, included) {
    super(initialData, included, {
      columns: [
        'id',
        'relatable_type',
        'relatable_id',
        'topic',
        'priority',
        'description',
        'aasm_state',
        'created_by_id',
        'closed_by_id',
        'closed_at',
        'created_at',
        'updated_at',
      ],
      dateKeys: [
        'closed_at',
        'created_at',
        'updated_at',
      ],
      relationships: {
        // relatable: { collection: false, polymorphic: { 'form_response': FormResponse } },
        // relatable: { collection: false, polymorphic: { 'form_response': FormResponse, 'training_center': TrainingCenter } },
        created_by: { collection: false, model: User },
        closed_by: { collection: false, model: User },
        issue_activity_items: { collection: true, model: IssueActivityItem },
      },
    })
  }
}

export default Issue